<template>
	<v-container>
		<v-row 
			justify = "center"
		>
			<v-col 
				xl 		= "7" 
				lg 		= "7" 
				md 		= "7" 
				sm 		= "7" 
				cols 	= "10"
			>
				<v-card 
					outlined
				>
					<v-card-title 
						v-text 	= "$ml.get('ms_sp')"  
						class 	= "justify-center body-2 primary pa-1"
					></v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-text-field 
							dense
							outlined  
							v-model = "code" 
							:label 	= "$ml.get('security_code')" 
						></v-text-field>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn 
							small 
							color  = "success" 
							v-text = "$ml.get('confirm')" 
							@click = "send" 
							v-show = "!loading"
						></v-btn>
						<v-progress-circular 
							indeterminate 
							v-show 	= "loading" 
							color 	= "primary" 
							class 	= "mr-4" 
							:size 	= "27"
						></v-progress-circular>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
		
	</v-container>
</template>
<script>
	import axios from 'axios';
	export default {
		name : 'security_psw',
		data : () => ({
			code 		: '',
			info 		: '',
			snackbar 	: false,
			color 		: '',
			loading 	: false,
		}),

		methods : {
			send(){
				this.loading 	= true;
				const id 		= this.code;
				const api 		= this.$URL + '/api/v1/auth/valid-password-token'
				axios.post( api,{ resettoken : this.code })
					.then(response => {
						// console.log(response, 'response')
						this.loading = false;
						this.$EventBus.$emit("notifications_modal",{
							type : "saved",
						})
						this.$router.push({name: 'recover_psw', params: { id: id } }); 
						//  {path:'/recover_user', params: {this.code} } / {path:`/recover_user/${this.code}` } / {path:'/recover_user/:id', params:  this.code } / {path:`/recover_user/${id}` }
						// console.log(this.router, 'router')
					}).catch( error => {
						this.loading = false;
						this.$EventBus.$emit("notifications_modal",{
							type 	: "error",
							message : error,
						})
					})
			}
		}
	};
</script>